import api from './client';

export const authAPI = {
  register: (email: string, password: string, name: string) =>
    api.post('/auth/register', { email, password, name }),
  
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),

  ssoStatus: () => api.get('/auth/sso/status'),
};

export const userAPI = {
  getAll: () => api.get('/users'),
  create: (data: any) => api.post('/users', data),
  update: (id: string, data: any) => api.put(`/users/${id}`, data),
  delete: (id: string) => api.delete(`/users/${id}`),
};

export const settingsAPI = {
  getSso: () => api.get('/settings/sso'),
  updateSso: (data: any) => api.put('/settings/sso', data),
  getPublic: () => api.get('/settings/public'),
};

export const contentAPI = {
  getAll: () => api.get('/content'),
  getById: (id: string) => api.get(`/content/${id}`),
  create: (data: any) => api.post('/content', data),
  update: (id: string, data: any) => api.put(`/content/${id}`, data),
  delete: (id: string) => api.delete(`/content/${id}`),
};

export const displayAPI = {
  getAll: () => api.get('/displays'),
  create: (data: any) => api.post('/displays', data),
  update: (id: string, data: any) => api.put(`/displays/${id}`, data),
  delete: (id: string) => api.delete(`/displays/${id}`),
  register: (name: string, location: string) =>
    api.post('/displays/register', { name, location }),
  heartbeat: (id: string) => api.post(`/displays/${id}/heartbeat`),
  getPlaylist: (id: string) => api.get(`/displays/${id}/playlist`),
  assignPlaylist: (id: string, playlistId: string) =>
    api.post(`/displays/${id}/playlist/${playlistId}`),
  assignSchedule: (id: string, scheduleId: string) =>
    api.post(`/displays/${id}/schedule/${scheduleId}`),
  removeSchedule: (id: string) =>
    api.delete(`/displays/${id}/schedule`),
  getSchedule: (id: string) => api.get(`/displays/${id}/schedule`),
  getConfig: (id: string) => api.get(`/displays/${id}/config`),
};

export const playlistAPI = {
  getAll: () => api.get('/playlists'),
  create: (data: any) => api.post('/playlists', data),
  update: (id: string, data: any) => api.put(`/playlists/${id}`, data),
  delete: (id: string) => api.delete(`/playlists/${id}`),
};

export const pageAPI = {
  getAll: () => api.get('/pages'),
  getById: (id: string) => api.get(`/pages/${id}`),
  create: (formData: FormData) =>
    api.post('/pages', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  update: (id: string, data: any) => api.put(`/pages/${id}`, data),
  uploadFiles: (id: string, formData: FormData) =>
    api.post(`/pages/${id}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  deleteFile: (id: string, fileIndex: number) =>
    api.delete(`/pages/${id}/files/${fileIndex}`),
  rotateFile: (id: string, fileIndex: number, rotation?: number) =>
    api.put(`/pages/${id}/files/${fileIndex}/rotate`, rotation === undefined ? {} : { rotation }),
  delete: (id: string) => api.delete(`/pages/${id}`),
};

export const scheduleAPI = {
  getAll: () => api.get('/schedules'),
  getById: (id: string) => api.get(`/schedules/${id}`),
  create: (data: any) => api.post('/schedules', data),
  update: (id: string, data: any) => api.put(`/schedules/${id}`, data),
  delete: (id: string) => api.delete(`/schedules/${id}`),
};

export const infoscreenAPI = {
  getAll: () => api.get('/infoscreens'),
  getById: (id: string) => api.get(`/infoscreens/${id}`),
  create: (data: any) => api.post('/infoscreens', data),
  update: (id: string, data: any) => api.put(`/infoscreens/${id}`, data),
  delete: (id: string) => api.delete(`/infoscreens/${id}`),
  addTicker: (id: string, data: any) => api.post(`/infoscreens/${id}/tickers`, data),
  updateTicker: (id: string, tickerId: string, data: any) => api.put(`/infoscreens/${id}/tickers/${tickerId}`, data),
  deleteTicker: (id: string, tickerId: string) => api.delete(`/infoscreens/${id}/tickers/${tickerId}`),
  addOpeningHours: (id: string, data: any) => api.post(`/infoscreens/${id}/opening-hours`, data),
  updateOpeningHours: (id: string, sectionId: string, data: any) => api.put(`/infoscreens/${id}/opening-hours/${sectionId}`, data),
  deleteOpeningHours: (id: string, sectionId: string) => api.delete(`/infoscreens/${id}/opening-hours/${sectionId}`),
  dumpFeed: (id: string) => api.post(`/infoscreens/${id}/dump-feed`),
};
